import React from 'react';
import { Badge, Group, Tooltip } from '@mantine/core';
import { getGermanStatusMessages, FIELD_SHORT_LABELS } from '../../../../../helpers/smokeDetectorHeadStatus';
import { SMOKE_DETECTOR_BADGE_COLORS } from '../../../../../helpers/smokeDetectorBadgeColors';

const SEVERITY_COLORS = {
  error: SMOKE_DETECTOR_BADGE_COLORS.error,
  warning: SMOKE_DETECTOR_BADGE_COLORS.warning,
  info: SMOKE_DETECTOR_BADGE_COLORS.neutral,
};

// Shared between the Rauchwarnmelder tab's detector table (SmokeDetectorRentalUnitGroup.jsx),
// MeterLogsDetailMeterReadingsModal.jsx, and ViewMeterReadingsForMeterModal.jsx's "Wert" column
// for SMOKE_DETECTOR meters, so all three screens render the exact same status badges from the
// same decoded Head Status.
// justify controls alignment of the badge group (a flex container) — a parent's `text-align`
// CSS only affects inline content, not a flex child's internal alignment, so callers that need
// right-aligned badges (e.g. a "Wert" column matching a right-aligned header) must pass
// justify="flex-end" explicitly rather than relying on the table cell's own text-align.
const SmokeDetectorStatusBadges = ({ decodedStatus, justify = 'flex-start' }) => {
  const flagged = getGermanStatusMessages(decodedStatus).filter((message) => message.severity !== 'ok');
  if (flagged.length === 0) {
    return (
      <Group justify={justify}>
        <Tooltip label="Keine Fehler oder Warnungen erkannt." withArrow zIndex={9999} position="top" transition="fade" transitionDuration={200}>
          <Badge
            className='smoke-detector-screen-badge'
            size="sm"
            style={{ color: SMOKE_DETECTOR_BADGE_COLORS.ok.color, backgroundColor: SMOKE_DETECTOR_BADGE_COLORS.ok.background }}
          >
            OK
          </Badge>
        </Tooltip>
      </Group>
    );
  }
  return (
    <Group gap={6} justify={justify}>
      {flagged.map(({ field, message, severity }) => (
        <Tooltip key={field} label={message} withArrow zIndex={9999} position="top" transition="fade" transitionDuration={200}>
          <Badge
            className='smoke-detector-screen-badge'
            size="sm"
            style={{ color: SEVERITY_COLORS[severity].color, backgroundColor: SEVERITY_COLORS[severity].background }}
          >
            {FIELD_SHORT_LABELS[field] || field}
          </Badge>
        </Tooltip>
      ))}
    </Group>
  );
};

export default SmokeDetectorStatusBadges;
